import(/* webpackMode: "eager" */ "/app/hub/src/app/[accountId]/error.tsx");
